import { updateIndexReading as updateIndexReadingAPI } from "../API/IndexReadings";
import { store } from "../store";

/**
 * Met à jour un relevé d'index existant et met à jour le store Redux
 * @param {string} dev_eui - EUI du device
 * @param {number} reading_id - ID du relevé
 * @param {Object} data - Données à mettre à jour
 * @returns {Promise<Object>} - Relevé mis à jour
 */
export default async function updateIndexReading(dev_eui, reading_id, data) {
  try {
    const result = await updateIndexReadingAPI(dev_eui, reading_id, data);

    // Met à jour le relevé dans le store Redux
    store.dispatch({
      type: "indexReadings/updateReading",
      payload: {
        dev_eui: dev_eui,
        reading_id: reading_id,
        updatedReading: result,
      },
    });

    return result;
  } catch (error) {
    console.error("Erreur lors de la mise à jour du relevé:", error);
    throw error;
  }
}
